import { FunnelTemplateService } from './FunnelTemplateService.types'
import { FunnelTemplateServiceImplementation } from './FunnelTemplateService'
import { FunnelTemplateServiceImplementationMock } from './FunnelTemplateService.mock'

export const funnelTemplateService: FunnelTemplateService =
  process.env.NODE_ENV === 'test'
    ? new FunnelTemplateServiceImplementationMock()
    : new FunnelTemplateServiceImplementation()
